import {isEmpty} from 'lodash';
import {Logger} from '../utils/Logger';
import {Injectable} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {LenderDetailsService} from '../service/lender-details.service';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class LenderPersonalInfoGuard implements CanActivate {
    private readonly router: Router;
    private readonly storageService: StorageService;
    private readonly lenderDetailsService: LenderDetailsService;

    constructor(storageService: StorageService, router: Router, lenderDetailsService: LenderDetailsService) {
        this.router = router;
        this.storageService = storageService;
        this.lenderDetailsService = lenderDetailsService;
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const response = await this.lenderDetailsService.getLenderDetails(lenderId);
        const lenderDetails = response.lender_info;

        if (isEmpty(lenderDetails)) {
            Logger.log(`Lender application is not found. Navigating to lender home page.`);
            this.router.navigate(['/invest']);
            return false;
        }

        if (isEmpty(lenderDetails.correspondence_address) || isEmpty(lenderDetails.correspondence_address.address)) {
            Logger.log(`Personal Information is not found in the lender application. Navigating to personal information page.`);
            this.router.navigate(['/lenderpersonalinfo']);
            return false;
        } else {
            return true;
        }
    }
}